import { useEffect, useState } from 'react';
export var useCheckDeviceWidth = function () {
    var _a = useState(false), isMobile = _a[0], setIsMobile = _a[1];
    useEffect(function () {
        var handleResize = function () {
            if (window.innerWidth < 1024) {
                setIsMobile === null || setIsMobile === void 0 ? void 0 : setIsMobile(true);
            }
            else
                setIsMobile(false);
        };
        window.addEventListener('resize', handleResize);
        handleResize();
        return function () { return window.removeEventListener('resize', handleResize); };
    }, []);
    return { isMobile: isMobile };
};
